import { AsyncData } from "@tsmono/util";

import { useLogDir } from "../app_config";
import { useCurrentLogFile } from "../app/routing/currentSelection";
import { LogHeader } from "../client/api/types";
import { useLogHeader } from "../log_data";

/** Selection binding: the selected log's details — the fetch trigger and
 *  loading/error surface (see `useLogHeader`). Active demand: this is the ONE
 *  consumer declaring "someone is looking at this log" — see
 *  `useLogHeader`'s `demand` option. */
export const useSelectedLogDetail = (): AsyncData<LogHeader | undefined> =>
  useLogHeader(useLogDir(), useCurrentLogFile(), { demand: "active" });

/** Whether the selected log's details are loading. Already false when no
 *  file is selected (`useLogHeader` idles as settled-undefined). */
export const useSelectedLogLoading = (): boolean =>
  useSelectedLogDetail().loading;
